import React from 'react'
import { connect } from 'react-redux'
import styles from './auth.scss'
import moment from 'moment'

import { logIn, appGetNofitications, setLang } from 'state/actions'

import i18n from 'lib/i18n'
const _ = i18n('login')

@connect(state => ({
	errors: state.auth.errors,
	dict: state.dict,
	notifications: state.notifications.items,
	language: state.app.lang
}))
export default class LoginBroker extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		errors: React.PropTypes.object,
	}

	constructor(props) {
		super(props)
		let localLang = localStorage.getItem('clientLanguage')
		this.state = { lang: localLang || 'nl' }
	}

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(appGetNofitications('broker'))
	}

	loginClicked(ev) {
		ev.preventDefault()

		const { dispatch } = this.props
		const { lang } = this.state

		const login = this.refs.login.value
		const password = this.refs.password.value

		dispatch(logIn(login, password, lang))
	}

	/**
	 * Get the notification message based on current app language
	 *
	 * @param {object} notification item data
	 */
	getNotificationMessage(notification) {
		const { language } = this.props
		let languageKey = 'message' + this.capitalizeFirstLetter(language)

		return notification[languageKey]
	}

	/**
	 * Validates if the notification is not expired
	 *
	 * @param {object} notification item data
	 */
	isValidNotification(notification) {
		if (notification.length < 1) {
			return false
		}

		const item = notification[0]
		const currentDate = moment()
		const notificationExpires = moment(item.expires)

		if (currentDate.isBefore(notificationExpires)) {
			return true
		}

		return false
	}

	onLanguageChange(lang) {
		const { dispatch } = this.props
		if (lang) {
			this.setState({ lang })
			dispatch(setLang(lang))
		}
	}

	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	render() {
		const { errors, notifications } = this.props
		const { lang } = this.state

		const langOptions = [
			{
				value: 'nl',
				label: _('nl')
			},
			{
				value: 'fr',
				label: _('fr')
			}
		]

		return (
			<div className={styles.authWrappNew}>
				<div className={styles.authFormsContainer}>
					<div className={styles.loginForm}>
						<div className={styles.langChanger}>
							{
								langOptions.map((langOption, key) => {
									return <span key={'langChange'+key} onClick={() => this.onLanguageChange(langOption.value)} className={lang === langOption.value ? styles.selectedLanguage : ''}>{(key !== 0 ? ' - ' : '') + langOption.label}</span>
								})
							}
						</div>
						<div className={styles.formImage}>
							<img src={require("resources/images/BE_Logo_OVB_Willemot_Blue_cmyk.svg")} />
						</div>
						<form id="casper_Wout" onSubmit={(ev) => this.loginClicked(ev)} method="post" className={styles.form} autoComplete="off">
							<input autoComplete="off" name="hidden" type="text" style={{ display: "none" }} />
							<div className={styles.formGroup}>
								<label>{_('login')}
									<input id="casper_user" autoFocus ref="login" />
								</label>
							</div>
							<div className={styles.formGroup}>
								<label>{_('password')}
									<input id="casper_pass" ref="password" type="password" autoComplete="new-password" />
								</label>
							</div>
							<div className={styles.errorMessage}>
								{errors && _(errors.id)}
							</div>
							<div className={styles.formGroup}>
								<button id="casper_butt" className={styles.submitButton}>{_('loginBttn')}</button>
							</div>
						</form>
					</div>
				</div>
				{notifications && notifications.length > 0 && this.isValidNotification(notifications) &&
					<div className={styles.notificationWrapper}>
						<span>
							{notifications.map((notification, key) => {
								return this.getNotificationMessage(notification)
							})}
						</span>
					</div>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/auth/loginBroker.jsx